export default {
  data: () => ({
    link_comissionados_auto_complete: '/comissionados/autocomplete',
    comissionadosCarregados: []
  }),
  methods: {
    getComissionadosBackoffice () {
      return this.$http.get(`/comissionados`).then(r => {
        return r.data
      }).catch(this.errComissionados)
    },
    async setComissionadosBackoffice (comissionados) {
      return this.$http.post('/comissionados/buscar_especificos', { comissionados }).then(r => {
        this.$session.set('comissionados', r.data)
      }).catch(this.errComissionados)
    }
  }
}
